export function isCardapioOnly(search) {
  const params = new URLSearchParams(search);
  if (!params.has('sc')) return false;
  const value = params.get('sc').trim().toLowerCase();
  return value === '' || value === 'true';
}

function storageKey(clienteId, search) {
  const params = new URLSearchParams(search);
  return `cardapio_return:${JSON.stringify([clienteId, params.get('x'), params.get('session_control')])}`;
}

export function isCardapioPath(pathname, clienteId) {
  const prefix = `/${clienteId}/cardapio`;
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function rememberCardapioPath(clienteId, pathname, search) {
  if (!isCardapioOnly(search) || !isCardapioPath(pathname, clienteId)) return;
  try {
    sessionStorage.setItem(storageKey(clienteId, search), pathname);
  } catch {
    // Navigation still works when browser storage is unavailable.
  }
}

export function getCardapioReturnUrl(clienteId, search) {
  const client = clienteId || new URLSearchParams(search).get('id_cliente');
  let pathname = `/${client}/cardapio/tipo/`;
  try {
    const saved = sessionStorage.getItem(storageKey(client, search));
    if (saved && isCardapioPath(saved, client)
      && !/[?#\\]/.test(saved) && !saved.split('/').some(segment => segment === '.' || segment === '..')) {
      pathname = saved;
    }
  } catch {
    // Direct cart access falls back to the menu selection screen.
  }
  return `${pathname}${search}`;
}
